import ControlledNav from '../components/applicationProfile/ControlledNav'
import { ApplicationProfileUpdateContainer } from '../components/applicationProfile/styles'

const ApplicationProfileUpdate = () => {
  return (
    <ApplicationProfileUpdateContainer>
      <ControlledNav />
    </ApplicationProfileUpdateContainer>
  )
}

export default ApplicationProfileUpdate
